import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '../../../base.component';

@Component({
  selector: 'app-add-edit-executive-plan',
  templateUrl: './add-edit-executive-plan.dialog.html',
  styleUrls: ['./add-edit-executive-plan.dialog.scss']
})
export class AddEditExecutivePlanComponent extends BaseComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddEditExecutivePlanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    super();
    this.initForm();
  }

  save() {
    const data = this.form.value;
    data.startDate = this.datePipe.transform(new Date(data.startDate), 'yyyy-MM-dd');
    data.endDate = this.datePipe.transform(new Date(data.endDate), 'yyyy-MM-dd');
    this.dialogRef.close(data);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private initForm() {
    this.form = this.fb.group({
      id: [this.data.model.id || null],
      clause: [{ value: this.data.model.clause || '', disabled: this.data.viewOnly }, [Validators.required]],
      startDate: [{ value: this.data.model.startDate || '', disabled: this.data.viewOnly }, [Validators.required]],
      endDate: [{ value: this.data.model.endDate || '', disabled: this.data.viewOnly }, [Validators.required]],
      responsibleName: [{ value: this.data.model.responsibleName || '', disabled: this.data.viewOnly }, [Validators.required]],
      responsiblePosition: [{ value: this.data.model.responsiblePosition || '', disabled: this.data.viewOnly }, [Validators.required]]
    });
  }
}
